module.exports = "<span id=\"refer\"></span>\r\n<fp-refer></fp-refer>";